import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.premixes;

export default class Premixes extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      name: this.string(''),
      type: this.string(''),
      product_needed: this.number(0),
      ingredients: this.attr([]),
    };
  }
}
